import React from "react";
import {Button, Input} from "antd";
import {SearchIcon} from "../icon/Icon";
import { SearchProps } from "antd/lib/input";
import './style.less';


const { Search } = Input;


interface SearchInputProps extends SearchProps {
    loading?: boolean;
}


/**
 * 自定义搜索框组件
 * @param props
 * @constructor
 */
const SearchInput = (props: SearchInputProps) => {
    const { loading, className, disabled, size = 'small' } = props;

    return (
        <Search
            allowClear={true}
            size={size}
            {...props}
            className={['custom-search-input', className ? className : ''].join(' ')}
            enterButton={ <Button disabled={disabled} loading={loading} icon={<SearchIcon />} /> }
        />
    )
}


export default SearchInput;
